import { render, staticRenderFns } from "./uploadwgt.vue?vue&type=template&id=435afda3&scoped=true&"
import script from "./uploadwgt.vue?vue&type=script&lang=js&"
export * from "./uploadwgt.vue?vue&type=script&lang=js&"
import style0 from "./uploadwgt.vue?vue&type=style&index=0&id=435afda3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435afda3",
  null
  
)

export default component.exports